// extracted by mini-css-extract-plugin
export default {"wrap":"EN-z","subtitle":"FN-z","contentWrap":"GN-z","imgWrap":"HN-z","heading":"IN-z","copy":"JN-z"};